import CurrencyFormat from 'react-number-format';
import { Col, Row } from 'reactstrap';

import ContentLoader from '../../../components/ContentLoader';
import { useDict } from '../../../contexts/LanguageContext';

const ProfileDashboard = ({
    readableWalletId,
    summaryData,
    countCurrentIssuer,
    countCurrentNote,
    countInvestedNote,
    totalInvestmentAmount,
    highestInvestmentMade,
    isFetching,
}) => {
    const dict = useDict();

    const renderWithContent = (component) => {
        if (isFetching) {
            return (
                <ContentLoader width="100" height="20" color="loader500">
                    <rect width="100%" height="100%" y="0" rx="4" ry="4" />
                </ContentLoader>
            );
        }

        return component;
    };

    return (
        <div className="myProfile__summary">
            <Row style={{ margin: '5px 0px 10px 5px' }}>
                <Col xs={6} className="text-orange" style={{ fontWeight: 500 }}>
                    {dict.investorId}
                </Col>
                <Col
                    xs={6}
                    className="text-orange"
                    style={{ fontWeight: 500, textAlign: 'right' }}
                >
                    {renderWithContent(readableWalletId)}
                </Col>
            </Row>
            <Row style={{ margin: '5px 0px 10px 5px' }}>
                <Col xs={6}>{dict.totalInvestment}</Col>
                <Col xs={6} style={{ textAlign: 'right' }} data-private>
                    {renderWithContent(
                        <CurrencyFormat
                            value={summaryData?.invest || '0.00'}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row>
            <Row
                style={{ margin: '5px 0px 10px 5px' }}
                className="text-profile"
            >
                <Col xs={6}>- {dict.totalWithdrawal}</Col>
                <Col xs={6} style={{ textAlign: 'right' }} data-private>
                    {renderWithContent(
                        <>
                            (
                            <CurrencyFormat
                                value={summaryData?.withdrawal || '0.00'}
                                displayType="text"
                                thousandSeparator
                                prefix="฿ "
                            />
                            )
                        </>
                    )}
                </Col>
            </Row>
            <Row
                style={{ margin: '5px 0px 10px 5px' }}
                className="text-profile shortLongText"
            >
                <Col xs={6}>{dict.balance}</Col>
                <Col xs={6} style={{ textAlign: 'right' }} data-private>
                    {renderWithContent(
                        <CurrencyFormat
                            value={summaryData?.balance || '0.00'}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row>
            {/* <Row
                style={{ margin: '5px 0px 10px 5px' }}
                className="text-profile"
            >
                <Col xs={6}>Current Notes</Col>
                <Col xs={6} style={{ textAlign: 'right' }} data-private>
                    {renderWithContent(
                        <span>
                            {countCurrentNote === '-' ? '0' : countCurrentNote}{' '}
                            note(s)
                        </span>
                    )}
                </Col>
            </Row>
            <Row style={{ margin: '5px 0px 5px 5px' }} className="text-profile">
                <Col xs={6}>Current Issuers</Col>
                <Col xs={6} style={{ textAlign: 'right' }} data-private>
                    {renderWithContent(
                        <span>
                            {countCurrentIssuer === '-'
                                ? '0'
                                : countCurrentIssuer}{' '}
                            issuer(s)
                        </span>
                    )}
                </Col>
            </Row> */}
        </div>
    );
};

export default ProfileDashboard;
